import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-female-tai-chi-walking-pr&exp=web_pix_payment_method_for_br~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-walking-f-pr__b'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-female-tai-chi-walking-v2&exp=web_pix_payment_method_for_br~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-walking-f-v2__b'
					),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-female-tai-chi-walking-v2-al&exp=web_pix_payment_method_for_br~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-walking-f-v2-al__b'
					),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-male-tai-chi-yoga-pr&exp=web_pix_payment_method_for_br~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-yoga-m-pr__b'
					),
			},
		},
	},
	{
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-female-tai-chi-walking-pr&exp=web_pix_payment_method_for_br~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-walking-f-pr__c'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-female-tai-chi-walking-v2&exp=web_pix_payment_method_for_br~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-walking-f-v2__c'
					),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-female-tai-chi-walking-v2-al&exp=web_pix_payment_method_for_br~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-walking-f-v2-al__c'
					),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=BR&area=activity-male-tai-chi-yoga-pr&exp=web_pix_payment_method_for_br~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pix_payment_method_for_br/tai-chi-yoga-m-pr__c'
					),
			},
		},
	},
]

export default config
